import { useMemo } from 'react';
import type {
  CommaDelimitedLocationType,
  Provider,
  LocationType,
} from '../types';
import LocationControl from '@grnhse/location-control';

export const useLocationControl = (
  locationType: CommaDelimitedLocationType,
  provider?: Provider
): LocationControl => {
  return useMemo(() => {
    const normalizedProvider = (
      provider || window.LocationControl.defaultProvider
    ).toLowerCase() as Provider;

    // the default provider uses title case for backwards compatibility with the jQuery location control, so we need
    // to convert it to lowercase before comparing.
    const config =
      normalizedProvider === 'pelias'
        ? window.LocationControl.Providers.Pelias
        : window.LocationControl.Providers.Mapbox;

    return new LocationControl({
      ...config,
      provider: normalizedProvider,
      locationTypes: locationType.split(',') as LocationType[],
    });
  }, [provider, locationType]);
};
